import React from 'react';

export default class ApiStatsDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            c:this.props.paylowd,
            d:this.props.respownse,
        }
    }
    
    render(){
        return(<React.Fragment><table><thead><tr>
            <th>Payload</th>
            </tr>
    </thead>
    <tbody>
        <tr>
            <td>{this.state.c}</td>
        </tr>
    </tbody>
    </table>
    <br></br>
    <table><thead><tr>
            <th>Response</th>
            </tr>
    </thead>
    <tbody>
        <tr>
            <td>{this.state.d}</td>
        </tr>
    </tbody>
    </table>
    </React.Fragment>
    );
    }
}